import { apiRequest } from '../client'

/**
 * Per-restaurant Viva payment configuration (CHG-2026-08-viva-isv,
 * CHG-2026-08-viva-direct-merchant). SUPER_ADMIN only on the backend: the fee is webbill's
 * commercial term, the merchant id determines where the money lands, and DIRECT configs carry
 * the merchant's credentials.
 */
export type VivaMode = 'DIRECT' | 'ISV'

export interface VivaConfig {
  restaurantId: number
  mode: VivaMode
  merchantId: string
  isvFeeCents: number
  sourceCode: string
  clientId: string | null
  clientSecret: string | null
  apiKey: string | null
  /** Path of the per-restaurant webhook handshake; prefix with the API origin for display. */
  webhookPath: string | null
}

export interface VivaConfigRequest {
  mode: VivaMode
  merchantId: string
  sourceCode: string
  isvFeeCents?: number
  clientId?: string
  clientSecret?: string
  apiKey?: string
}

const base = (restaurantId: number) =>
  `/api/v1/admin/restaurants/${restaurantId}/payment-provider/viva`

export const vivaConfigApi = {
  get: (restaurantId: number) => apiRequest<VivaConfig>(base(restaurantId)),

  save: (restaurantId: number, data: VivaConfigRequest) =>
    apiRequest<VivaConfig>(base(restaurantId), {
      method: 'PUT',
      body: JSON.stringify(data),
    }),

  remove: (restaurantId: number) =>
    apiRequest<void>(base(restaurantId), { method: 'DELETE' }),
}
